import { LanguageEnum } from '../../../../utils';

export const copyWritings = {
  title: {
    [LanguageEnum.chinese]: '关系图示例 VGraph demo',
    [LanguageEnum.english]: 'Graph Examples VGraph demo',
  },
  description: {
    [LanguageEnum.chinese]: 'VGraph demo:',
    [LanguageEnum.english]: 'VGraph demo:',
  },
};
